interface TimelineSummaryProps {
  onset: number | null;
  peak: number | null;
  duration: number | null;
}

interface TimelineItem {
  label: string;
  value: number;
}

export function TimelineSummary({ onset, peak, duration }: TimelineSummaryProps) {
  const items: TimelineItem[] = [];

  if (onset != null) {
    items.push({ label: 'Onset', value: onset });
  }
  if (peak != null) {
    items.push({ label: 'Peak', value: peak });
  }
  if (duration != null) {
    items.push({ label: 'Duration', value: duration });
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="timeline-summary" role="group" aria-label="Experience timeline">
      <dl className="timeline-items">
        {items.map((item, index) => (
          <div key={item.label} className="timeline-item">
            {index > 0 && (
              <span className="timeline-connector" aria-hidden="true">→</span>
            )}
            <dt className="timeline-label">{item.label}</dt>
            <dd className="timeline-value">
              {item.value} <span className="timeline-unit">min</span>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
